import React from "react";
import { useDragLayer } from "react-dnd";
import { make as Hex } from "./TeamPlannerHex17.bs";
import { make as UnitPreview } from "../team-planner-core/TbUnitPreview.bs";
import { make as ItemPreview } from "../team-planner-core/TbItemPreview.bs";
import { make as HexPreview } from "./HexPreview17.bs";
import { make as HexItemPreview } from "../team-planner-core/TbHexItemPreview.bs";

const layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
};

function getItemStyles(currentOffset) {
  if (!currentOffset) {
    return {
      display: "none",
    };
  }
  let { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
  };
}

export const Preview = () => {
  const { isDragging, currentOffset, item } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging || !currentOffset) {
    return null;
  } else if (item.type === "unit" || item.id === "TFT12_Yuumi") {
    return (
      <div style={layerStyles}>
        <div style={getItemStyles(currentOffset)}>
          <UnitPreview unitId={item.id} />
        </div>
      </div>
    );
  } else if (item.type === "item") {
    return (
      <div style={layerStyles}>
        <div
          style={getItemStyles(currentOffset)}
          className="border border-white w-[34px] h-[34px]"
        >
          <ItemPreview itemId={item.id} shadow={item.shadow} size={32} />
        </div>
      </div>
    );
  } else if (item.type === "hex") {
    if (item.unitId) {
      const co = {
        ...currentOffset,
        y: currentOffset.y - 10,
      };
      return (
        <div style={layerStyles}>
          <svg style={getItemStyles(co)}>
            <g
              style={{
                transform: "translate(0px, 10px)",
              }}
            >
              <HexPreview
                unitId={item.unitId}
                unitItems={item.unitItems}
                starLevel={item.starLevel || 0}
                traitCounts={item.traitCounts}
                modifier={item.modifier}
              />
            </g>
          </svg>
        </div>
      );
    } else {
      return null;
    }
  } else if (item.type === "hex-item") {
    return (
      <div style={layerStyles}>
        <div style={getItemStyles(currentOffset)}>
          <HexItemPreview itemId={item.id} shadow={item.shadow} />
        </div>
      </div>
    );
  }

  return null;
};
